import styled from "styled-components";

export const StyledSection1 = styled.div`
  .section1-container {
    display: flex;
    justify-content: center;
    padding-top: 32px;
    height: max-content;
    .frame {
      width: 700px;
      height: max-content;
      .title-box {
        display: flex;
        align-items: center;
        gap: 8px;
        & > p {
          color: #494949;
          font-size: 22px;
          font-weight: 700;
          line-height: 29px;
        }
        svg {
          width: 26px;
          height: 26px;
        }
      }
    }

    .frame-r {
      .region-title {
        width: max-content;
        font-size: 34px;
        font-weight: 700;
        line-height: 64px;
        color: #494949;
        padding-top: 4px;
      }
    }
  }
`;
